import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { declineByCustomer } from 'data-providers/applicationsProvider';
import { hidenCreditRefusalPopup, prepareApplicationForClosing } from 'store/applications';

export const useCreditRefusalPopupPresenter = () => {
  const rootDispatch = useDispatch();
  const { showCreditRefusalPopup, prepareApplicationForClosingData } = useSelector(
    (store) => store?.applications
  );
  const { applicationId, lastStateId } = prepareApplicationForClosingData;

  const onCloseCreditRefusalPopupHandler = useCallback(() => {
    rootDispatch(hidenCreditRefusalPopup());
    rootDispatch(
      prepareApplicationForClosing({
        applicationId: null,
        lastStateId: null,
      })
    );
  }, [rootDispatch]);

  const requestOnCreditRefusal = useCallback(() => {
    if (lastStateId <= 2) {
      declineByCustomer(applicationId, 'before');
    } else {
      declineByCustomer(applicationId, 'after');
    }
    onCloseCreditRefusalPopupHandler();
  }, [applicationId, lastStateId, onCloseCreditRefusalPopupHandler]);

  return { showCreditRefusalPopup, onCloseCreditRefusalPopupHandler, requestOnCreditRefusal };
};
